let icc_tool_api_host = window._env_ ? window._env_.REACT_APP_ICC_TOOL_API_HOST: "";

if (icc_tool_api_host && !icc_tool_api_host.endsWith("/")) icc_tool_api_host += "/";

export const DOMAINS = {
    icc_tool_api_host: icc_tool_api_host
};
